module.exports = __webpack_public_path__ + "img/ruins.9a11d5b2.jpg";